import { Component, ElementRef, EventEmitter, Input, OnInit, Optional, Output, Self, ViewChild } from '@angular/core';
import { FormGroupDirective, NgControl } from '@angular/forms';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'superflex-multiselect',
  template:`
    <label for="multiselect"> {{ label }} <span *ngIf="ngControl.control.errors?.required" style="font-weight: 900;">*</span> </label>
    <p-multiSelect
        [readonly]="readonly"
        [formControl]='ngControl.control'
        [optionLabel]="optionLabel" 
        [optionValue]="optionValue"
        [options]="options">
    </p-multiSelect>
    <app-error [input]="ngControl.control" [form]="form" ></app-error>
  `,
  host: {'class': 'p-field'}
})
export class MultiselectComponent implements OnInit {

    @Input() isDisabled: boolean
    @Input() readonly: boolean = false
    @Input() label: string = ''
    @Input() filter: boolean = false
    @Input() options: SelectItem[] = []

    @Input() display = '';
    @Input() optionLabel = '';
    @Input() optionValue = '';

    @Input() placeholder = '';
    @ViewChild('rb') inputViewChild: ElementRef;

    @Output() onFocus: EventEmitter<any> = new EventEmitter();
    @Output() onBlur: EventEmitter<any> = new EventEmitter();

    public checked: boolean;
    public focused: boolean;

    form!: FormGroupDirective;

    constructor(@Self() @Optional() public ngControl: NgControl, private rootFormGroup: FormGroupDirective) {
        this.form = this.rootFormGroup;
        if (this.ngControl) {
            ngControl.valueAccessor = this
        }
    }

    writeValue(value: any): void {
        //
    }
    registerOnChange(fn: any): void {
        //
    }
    registerOnTouched(fn: any): void {
        //
    }
    setDisabledState?(isDisabled: boolean): void {
        //
    }

    public onModelTouched = () => {/** */ };

    ngOnInit(): void {
        if (this.isDisabled) {
            this.ngControl.control.disable()
        } else {
            this.ngControl.control.enable()
        }
    }

    onInputFocus(event): void {
        this.focused = true;
        this.onFocus.emit(event);
    }

    onInputBlur(event): void {
        this.focused = false;
        this.onModelTouched();
        this.onBlur.emit(event);
    }

    focus(): void {
        this.inputViewChild.nativeElement.focus();
    }

    ngOnDestroy(): void {
        // this.registry.remove(this);
    }

    getPlaceholderPrefix(): string {
        return this.isDisabled ? '' : 'FORM_ERRORS.placeholder';
    }
}
